import { render, staticRenderFns } from "./describe.vue?vue&type=template&id=6df1cfcd&"
import script from "./describe.vue?vue&type=script&lang=js&"
export * from "./describe.vue?vue&type=script&lang=js&"
import style0 from "./describe.vue?vue&type=style&index=0&id=6df1cfcd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports